<!-- Header -->
<section class="hero-section bg-primary text-white py-5">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-8">
        <h1 class="display-4 fw-bold mb-4">
          Nuestro método
        </h1>
        <p class="lead mb-4">
          Metodología integral para la inclusión laboral de personas con discapacidad
        </p>
      </div>
             <div class="col-lg-4">
         <div class="hero-image text-center">
           <img src="assets/images/como-trabajamos.png" alt="Metodología de trabajo" class="img-fluid">
         </div>
       </div>
    </div>
  </div>
</section>

<!-- Main Content -->
<main>
  <!-- Timeline del Flujo de Servicio -->
  <section class="timeline-section py-5">
    <div class="container">
      <h2 class="text-center mb-5">Proceso de Inclusión Laboral</h2>
      <div class="timeline">
        <div class="row">
          <div class="col-lg-4 col-md-6 mb-4" *ngFor="let paso of flujoServicio">
            <div class="timeline-item text-center">
              <div class="timeline-marker bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
                <span class="fw-bold">{{ paso.paso }}</span>
              </div>
              <div class="timeline-content">
                <h5 class="h6 mb-2">{{ paso.titulo }}</h5>
                <p class="small text-muted mb-2">{{ paso.descripcion }}</p>
                
                <div class="timeline-details">
                  <div class="mt-2">
                    <small class="text-muted">Entregable:</small>
                    <div class="fw-bold">{{ paso.entregable }}</div>
                  </div>
                  <div class="mt-2">
                    <small class="text-muted">Duración:</small>
                    <div class="fw-bold text-primary">{{ paso.duracion }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Metodología -->
  <section class="metodologia-section py-5 bg-light">
    <div class="container">
      <h2 class="text-center mb-5">Nuestra Metodología</h2>
      <div class="row">
        <div class="col-lg-8 mx-auto">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-4">
              <h4 class="text-center mb-4">{{ metodologia.enfoque }}</h4>
              
              <div class="row">
                <div class="col-md-6">
                  <h5 class="mb-3">Principios</h5>
                  <ul class="list-unstyled">
                    <li *ngFor="let principio of metodologia.principios" class="mb-2">
                      <i class="fas fa-check text-success me-2"></i>{{ principio }}
                    </li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <h5 class="mb-3">Herramientas</h5>
                  <ul class="list-unstyled">
                    <li *ngFor="let herramienta of metodologia.herramientas" class="mb-2">
                      <i class="fas fa-tools text-primary me-2"></i>{{ herramienta }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- RACI Simplificado -->
  <section class="raci-section py-5">
    <div class="container">
      <h2 class="text-center mb-5">RACI por Fase</h2>
      <div class="table-responsive">
        <table class="table table-striped table-hover">
          <thead class="table-dark">
            <tr>
              <th scope="col">Fase</th>
              <th scope="col">Responsable</th>
              <th scope="col">Aprobador</th>
              <th scope="col">Consultado</th>
              <th scope="col">Informado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of raci">
              <td><strong>{{ item.fase }}</strong></td>
              <td>{{ item.responsable }}</td>
              <td>{{ item.aprobador }}</td>
              <td>{{ item.consultado }}</td>
              <td>{{ item.informado }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <!-- Métricas de Control -->
  <section class="metricas-section py-5 bg-light">
    <div class="container">
      <h2 class="text-center mb-5">Métricas de Control</h2>
      <div class="row">
        <div class="col-lg-2 col-md-4 mb-4" *ngFor="let metrica of metricasControl">
          <div class="metric-card text-center">
            <div class="metric-icon mb-3">
              <i [class]="metrica.icono + ' fa-3x text-' + metrica.color"></i>
            </div>
            <div class="metric-value h4 fw-bold mb-2">{{ metrica.valor }}</div>
            <div class="metric-category h6 mb-2">{{ metrica.categoria }}</div>
            <div class="metric-description small text-muted">{{ metrica.descripcion }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Tiempos de Entrega -->
  <section class="tiempos-section py-5">
    <div class="container">
      <h2 class="text-center mb-5">Tiempos de Entrega</h2>
      <div class="row">
        <div class="col-md-3 mb-4">
          <div class="card text-center h-100">
            <div class="card-body">
              <i class="fas fa-rocket fa-3x text-primary mb-3"></i>
              <h5 class="card-title">Servicio Express</h5>
              <p class="card-text">{{ tiempos.servicioExpress }}</p>
              <small class="text-muted">Implementación rápida</small>
            </div>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="card text-center h-100">
            <div class="card-body">
              <i class="fas fa-cogs fa-3x text-primary mb-3"></i>
              <h5 class="card-title">Servicio Estándar</h5>
              <p class="card-text">{{ tiempos.servicioEstandar }}</p>
              <small class="text-muted">Implementación completa</small>
            </div>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="card text-center h-100">
            <div class="card-body">
              <i class="fas fa-users fa-3x text-primary mb-3"></i>
              <h5 class="card-title">Transformación Cultural</h5>
              <p class="card-text">{{ tiempos.transformacionCultural }}</p>
              <small class="text-muted">Cambio sostenible</small>
            </div>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="card text-center h-100">
            <div class="card-body">
              <i class="fas fa-chart-line fa-3x text-primary mb-3"></i>
              <h5 class="card-title">Seguimiento</h5>
              <p class="card-text">{{ tiempos.seguimiento }}</p>
              <small class="text-muted">Acompañamiento continuo</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Muestra de Entregables -->
  <section class="entregables-section py-5 bg-light">
    <div class="container">
      <h2 class="text-center mb-5">Muestra de Entregables</h2>
      <div class="row">
        <div class="col-lg-3 col-md-6 mb-4" *ngFor="let entregable of entregables">
          <div class="card h-100 border-0 shadow-sm">
            <div class="card-body">
              <div class="text-center mb-3">
                <i [class]="entregable.icono + ' fa-3x text-primary'"></i>
              </div>
              <h5 class="card-title text-center">{{ entregable.titulo }}</h5>
              <p class="card-text">{{ entregable.descripcion }}</p>
              
              <div class="entregable-details">
                <p class="mb-2">
                  <strong>Formato:</strong> {{ entregable.formato }}
                </p>
                <p class="mb-3">
                  <strong>Preview:</strong> {{ entregable.preview }}
                </p>
              </div>
              
              <button class="btn btn-outline-primary w-100" (click)="descargarEntregable(entregable)">
                <i class="fas fa-download me-2"></i>Descargar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Casos de Éxito -->
  <section class="casos-exito-section py-5">
    <div class="container">
      <h2 class="text-center mb-5">Casos de Éxito</h2>
      <div class="row">
        <div class="col-lg-6 mb-4" *ngFor="let caso of casosExito">
          <div class="card h-100 border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h5 class="card-title mb-1">{{ caso.empresa }}</h5>
                  <p class="text-muted mb-0">{{ caso.sector }} • {{ caso.empleados }} empleados</p>
                </div>
                <span class="badge bg-success">Éxito</span>
              </div>
              
              <div class="row mb-3">
                <div class="col-6">
                  <small class="text-muted">Tiempo de implementación:</small>
                  <div class="fw-bold">{{ caso.tiempo }}</div>
                </div>
                <div class="col-6">
                  <small class="text-muted">Resultado:</small>
                  <div class="fw-bold text-success">{{ caso.resultado }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Garantías -->
  <section class="garantias-section py-5 bg-primary text-white">
    <div class="container">
      <h2 class="text-center mb-5">Nuestras Garantías</h2>
      <div class="row">
        <div class="col-lg-4 mb-4" *ngFor="let garantia of garantias">
          <div class="card border-0 bg-transparent text-white">
            <div class="card-body text-center">
              <i [class]="garantia.icono + ' fa-3x mb-3'"></i>
              <h5 class="card-title">{{ garantia.titulo }}</h5>
              <p class="card-text">{{ garantia.descripcion }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Final -->
  <section class="cta-final py-5">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-lg-8">
          <h2 class="mb-4">¿Listo para empezar tu transformación?</h2>
          <p class="lead mb-4">Nuestro equipo de consultores está listo para acompañarte en todo el proceso</p>
          <button class="btn btn-primary btn-lg px-5" (click)="contactarConsultor()">
            <i class="fas fa-phone me-2"></i>Contáctanos
          </button>
        </div>
      </div>
    </div>
  </section>
</main>
